import { render, staticRenderFns } from "./BotEditGrid.vue?vue&type=template&id=3f90d88c&"
import script from "./BotEditGrid.vue?vue&type=script&lang=js&"
export * from "./BotEditGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports